module.exports = __webpack_public_path__ + "img/背景元素-2@2x.6b7d07ae.png";